import React from 'react';
import { Text } from '../../components/Text';
import { Wrapper } from '../../components/Wrapper';
import { Divider } from '../../components/Divider';
import { HeroSection } from '../../components/HeroSections/FirstPage';
import { StrongWordTextSection } from '../../components/StrongWordTextSection';
import { Layout } from '../../components/Layout';
import { HeroContainer } from '../../components/HeroСontainer';
import { PercentSection } from '../../components/PercentSection';
import { DownloadButton } from '../../components/DownloadButton';
import { TextList } from '../../components/TextList';
import { References } from '../../components/References';
import { Subtitle } from '../../components/Text/Subtitle';
import styles from './ThirdTemplate.styles';

const ThirdTemplate = ({
  pageContext: {
    PageData: {
      seo,
      hero,
      text,
      titles,
      sectionWithPostFirst,
      sectionWithPostsSecond,
      navigation,
      imagesCommon,
      percentSection,
      textButton,
      references,
      reports,
    },
  },
  location,
}) => (
  <Layout
    props={seo}
    navigation={navigation}
    locationPathName={location.pathname}
    imagesCommon={imagesCommon}
    logo={imagesCommon.logoHeadAdv}>
    <div className="article" css={styles(hero.backgroundColor, hero.backgroundColorFooter)}>
      <HeroContainer propsHero={hero} propsCommon={imagesCommon}>
        <HeroSection props={hero} report={reports.one} textButton={textButton} downloadImg={imagesCommon.downloadImg} />
      </HeroContainer>
      <Divider height={8} />
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        <Subtitle
          text={titles.first}
          fontSize={24}
          lineHeight={28}
          maxWidth={'100%'}
          width={'100%'}
          fontWeight={'normal'}
        />
        <Divider height={4} heightMobile={6} />
        <Text text={text.sixth} width={'100%'} />
        <TextList text={text.seventh} />
      </Wrapper>
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        <Text text={text.first} width={'100%'} />
        <Divider height={4} heightMobile={8} />
      </Wrapper>
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        <Text text={text.second} width={'100%'} />
      </Wrapper>
      <Divider height={6} heightMobile={8} />
      <div className="article__posts-block-background article__posts-block-background--small-size" />
      <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'90%'}>
        <div className="article__posts-block-first">
          <StrongWordTextSection
            title={sectionWithPostFirst.title}
            posts={sectionWithPostFirst.posts}
            width={'1024px'}
            height={'339'}
            subtitleWidth={'100%'}
            subtitleMaxWidth={'400px'}
            fontSizeLastWord={72}
            lineHeightLastWord={90}
            marginFirstColumn={{
              top: 63,
              right: 0,
              bottom: 0,
              left: 0,
            }}
            marginSecondColumn={{
              top: 32,
              right: 0,
              bottom: 0,
              left: 16,
            }}
          />
        </div>
      </Wrapper>
      <Divider height={10} heightMobile={8} />
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        <Text text={text.third} width={'100%'} />
      </Wrapper>
      <Divider height={6} heightMobile={8} />
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        {percentSection && (
          <div className="article__posts-block-quote">
            <Text text={text.fourth} width={'47%'} />
            <PercentSection props={percentSection} />
          </div>
        )}
      </Wrapper>
      <Divider height={4} heightMobile={6} />
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        <TextList title={titles.second} text={text.fifth} />
        <DownloadButton report={reports.one} downloadImg={imagesCommon.downloadImg} textButton={textButton} />
      </Wrapper>
      <Divider height={4} heightMobile={6} />
      <div className="article__posts-block-background-footer">
        <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'90%'}>
          <div className="article__posts-block-second">
            <StrongWordTextSection
              className="logo-right"
              title={sectionWithPostsSecond.title}
              posts={sectionWithPostsSecond.posts}
              width={'1024px'}
              height={'339'}
              subtitleWidth={'100%'}
              subtitleMaxWidth={'400px'}
              fontSizeLastWord={72}
              lineHeightLastWord={90}
              align-first-column="0 center"
              alignFirstColumnFlexContainer={{
                alignItems: 'flex-start',
                justifyContent: 'center',
              }}
              marginSecondColumn={{
                top: 48,
                right: 0,
                bottom: 0,
                left: 16,
              }}
            />
          </div>
        </Wrapper>
      </div>
      <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'90%'}>
        <Divider height={6} heightMobile={8} />
        <References references={references} />
        <Divider height={6} heightMobile={8} />
      </Wrapper>
    </div>
  </Layout>
);

export default ThirdTemplate;
